import { render, staticRenderFns } from "./AddJobFeedForm.vue?vue&type=template&id=21519cc0&"
import script from "./AddJobFeedForm.vue?vue&type=script&lang=ts&"
export * from "./AddJobFeedForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddJobFeedForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports